import { Currencies, CurrenciesSymbols } from "./getCurrencySymbol";

export const totalBill = (currency: Currencies, amount: string | number) => {
  if (currency === "SEK") {
    return amount + CurrenciesSymbols[currency];
  }
  return CurrenciesSymbols[currency] + amount;
};
